import React, { useEffect } from "react";
import { useRive, useStateMachineInput } from "@rive-app/react-canvas";
const RiveComponent = () => {
  // Load Rive animation
  const { rive, RiveComponent } = useRive({
    src: "/interactive_model.riv", // Update with the correct path
    stateMachines: "FaceTracking-StateMachine",
    autoplay: true,
  });
  // State Machine Inputs
  const isTracking = useStateMachineInput(rive, "FaceTracking-StateMachine", "Parent-isTracking");
  const toggleGlasses = useStateMachineInput(rive, "FaceTracking-StateMachine", "ToggleGlasses");
  const toggleBlush = useStateMachineInput(rive, "FaceTracking-StateMachine", "ToggleBlush");
  // Handle mouse movement for tracking (only if `Parent-isTracking` is Boolean)
  useEffect(() => {
    if (!isTracking) return;
    const handleMouseMove = () => {
      isTracking.value = true;
    };
    const handleMouseLeave = () => {
      isTracking.value = false;
    };
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseleave", handleMouseLeave);
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, [isTracking]);
  return (
    <div className="flex flex-col items-center gap-4">
      {/* Render Rive animation */}
      <RiveComponent style={{ width: "500px", height: "500px" }} />
      {/* Buttons to toggle blush & glasses */}
      
    </div>
  );
};
export default RiveComponent;